<template>
    <div id="app">
        <router-view/>
        <el-image-viewer
            v-if="photoViewer.status"
            z-index="9999"
            :url-list="[photoViewer.path]"
            :on-close="() => photoViewer.status = false"
        />
    </div>
</template>

<script>
import router from '@/router'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    name: 'App',
    components: {
        ElImageViewer
    },
    provide: function () {
        return {
            back: this.back,
            goPage: this.goPage,
            tel: this.tel,
            anyPreview: this.anyPreview
        }
    },
    data () {
        return {
            photoViewer: {
                status: false,
                path: null
            }
        }
    },
    created () {
        this.$root.$on('showPhotoViewer', (src) => {
            this.photoViewer.status = true
            this.photoViewer.path = src
            console.log(this.photoViewer)
        })
    },
    methods: {
        back (step = -1) {
            router.go(step)
        },
        goPage (path) {
            router.push({ path })
        },
        tel (tel) {
            window.location.href = 'tel://' + tel
        },
        anyPreview (src) {
            this.$filePreview.toPreview(src)
        }
    }
}
</script>

<style>
    html,
    body,
    #app {
        width: 100%;
        height: 100%;
    }
</style>
